import Note from './component';
import { NoteProps } from './types';

export default Note;
export type { NoteProps };
